<template>
  <div class="container">
    <breadcrumb v-if="!isMobile" crumb="driver-list" />
    <section v-if="!isMobile" class="driver_section_filter">
      <el-row>
        <el-col :span="12">
          <search-input
            v-model="search_input"
            placeholder="Поиск по ФИО водителя"
            @clear="clearFilter"
            @search="filterDriverList"
            @input="onInput"
          />
        </el-col>
        <el-col :span="12" class="top-section-right">
          <div class="center" style="justify-content: flex-end">
            <p @click="$router.push({ path: '/driver/add' })">
              Добавить водителя
            </p>
          </div>
          <approve-filters
            :loading="loadingStats"
            :statistics="approvStatistics"
            :status="status"
            @setStatus="setStatus"
          />
        </el-col>
      </el-row>
      <p class="select-all-d">
        <el-checkbox
          v-if="filteredDriverList.length && !loading"
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          Выбрать все
        </el-checkbox>
      </p>
    </section>
    <section
      v-if="isMobile"
      class="top-section top-section_driver"
      style="padding-top: 10px"
    >
      <el-button
        type="primary"
        style="width: 100% !important"
        @click="$router.push({ path: '/driver/add' })"
      >
        Добавить водителя
      </el-button>
    </section>
    <el-table
      v-if="loading || !filteredDriverList.length"
      v-loading="loading"
      :data="filteredDriverList"
      style="width: 100%; height: 40vh; margin-top: 40px"
    />
    <section
      v-if="filteredDriverList.length && !loading"
      v-loading="isDeleting"
      class="middle-section middle-section_driver"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-checkbox-group
            v-model="checkedDrivers"
            @change="handleCheckedCitiesChange"
          >
            <transition-group name="slide-fade" tag="div">
              <div
                v-for="d in filteredDriverList"
                :key="d.id"
                class="check-list"
                @click="infoDriver(d, $event)"
              >
                <el-row :gutter="24" type="flex" align="middle">
                  <el-col v-if="!isMobile" class="auto-list_col" :span="1">
                    <div class="check-list-time auto-list_col_centered">
                      <el-checkbox :label="d" :value="d" />
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="3">
                    <div class="check-list-person grey check-list_date">
                      <p>{{ d.updated_at | wordDate }}</p>
                      <p>{{ d.updated_at | sliceDate }}</p>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="2">
                    <div class="check-list-person auto-list_col_centered">
                      <p>
                        <accreditation-lists-icon :approve-data="d" />
                      </p>
                    </div>
                  </el-col>

                  <el-col class="auto-list_col" :xs="10" :sm="4">
                    <div
                      class="check-list-person auto-list_col_centered"
                      :style="isMobile ? 'text-align:center' : ''"
                    >
                      <p>{{ shortFio(d.fio.trim()) }}</p>
                      <el-rate
                        v-if="!isMobile"
                        v-model="rate_user"
                        disabled
                        :colors="rate_color"
                      />
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="5">
                    <div class="check-list-person grey check-list_phone">
                      <p>{{ d.phone }}</p>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="6">
                    <div class="check-list-person grey auto-list_col_centered">
                      <p>{{ d.carrier_name }}</p>
                      <el-rate
                        v-if="!isMobile"
                        v-model="rate_user"
                        disabled
                        :colors="rate_color"
                      />
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="3">
                    <div class="check-list-action auto-list_col_centered">
                      <div>
                        <el-tooltip
                          :content="
                            d.is_6ndfl_approved
                              ? 'Документ 6-НДФЛ проверен'
                              : 'Нет проверенного документа 6-НДФЛ'
                          "
                          placement="top"
                          effect="light"
                        >
                          <p
                            class="single-p"
                            :class="
                              d.is_6ndfl_approved ? 'black_color' : 'red_color'
                            "
                          >
                            6-НДФЛ
                          </p>
                        </el-tooltip>
                      </div>
                    </div>
                  </el-col>
                  <el-col class="auto-list_col double_button" :xs="4" :sm="2">
                    <div class="check-list-action">
                      <p>
                        <el-button
                          data-goal="1"
                          type="danger"
                          icon="el-icon-delete"
                          class="no-events"
                          circle
                          @click="beforeDelete(d.id)"
                        />
                      </p>
                      <p>
                        <el-button
                          type="success"
                          icon="el-icon-edit"
                          class="no-events"
                          circle
                          @click="infoDriver(d, $event, 1)"
                        />
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </transition-group>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </section>

    <section
      v-if="!isMobile && filteredDriverList.length && !loading"
      class="bottom-section"
    >
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
      <div class="bottom-section-action">
        <p>Выбрано {{ checkedDrivers.length }} водителей</p>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(2)"
          >
            ОТКАЗАТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(1)"
          >
            УТВЕРДИТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            type="info"
            plain
            :disabled="!checkedDrivers.length"
            @click="beforeDelete()"
          >
            <p>Удалить</p>
          </el-button>
        </el-col>
      </div>
    </section>
    <driver-edit
      :edit-driver="editDriver"
      :close-modal="closeModal"
      :dialog-visible="dialogVisible"
    />
  </div>
</template>

<script>
import {
  GET_DRIVERS,
  GET_FILTER_DRIVERS,
  UPDATE_DRIVER,
} from '@/store/actions/drivers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getFilterStatus } from '@/helpers/functions'
import { mapGetters, mapState } from 'vuex'
import AccreditationListsIcon from '@/components/Accreditation/AccreditationListsIcon'
import ApproveFilters from '@/components/Shared/ApproveFilters'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import DriverEdit from './Driver-edit'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import SearchInput from '@/components/Shared/SearchInput'

const Approvements = RepositoryFactory.get('approvements')
const Driver = RepositoryFactory.get('driver')

export default {
  name: 'DriverList',
  components: {
    PaginationCustom,
    DriverEdit,
    Breadcrumb,
    ApproveFilters,
    SearchInput,
    AccreditationListsIcon,
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checkedDrivers: [],
      curPage: 1,
      rate_user: 3,
      rate_color: ['#3498DB', '#3498DB', '#3498DB'],
      dialogVisible: false,
      editDriver: {},
      status: '',
      search_input: '',
      isDeleting: false,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'drivers/getLoading',
      driver_list: 'drivers/getDrivers',
      pagination: 'drivers/getPagination',
    }),
    ...mapState('drivers', ['approvStatistics', 'loadingStats']),
    filteredDriverList() {
      return this.driver_list
    },
  },
  watch: {
    status: {
      handler: 'getDriverList',
    },
    driver_list: {
      handler(val) {
        if (val.length === 0 && this.isDriverRole && !this.search_input) {
          this.$alert(
            'У вас нет ни одного добавленного водителя. Добавьте водителя.',
          )
          this.$router.push('/driver/add')
        }
      },
    },
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    async loadPage() {
      if (this.$route.query.fio) {
        this.search_input = this.$route.query.fio
        this.filterDriverList()
      } else {
        this.getDriverList()
      }

      this.checkStatusFilter()
      await this.$store.dispatch('drivers/fetchDriversStats')
    },
    onInput(cur) {
      this.search_input = cur
    },
    setStatus(status) {
      this.status = status || ''
    },
    checkStatusFilter() {
      const query = this.$route.query

      if (query.status && query.status === '0') {
        this.status = query.status
      }
    },
    getDriverList(value) {
      const status = getFilterStatus(value)

      this.$store.dispatch(`drivers/${GET_DRIVERS}`, {
        page: this.curPage,
        status,
      })
    },
    changePage(page = 1) {
      this.curPage = page
      this.filterDriverList()
    },
    filterDriverList() {
      const filterValue = String(this.search_input).trim()

      if (filterValue.length > 2) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          fio: filterValue,
        })
      }
      if (!filterValue) {
        this.getDriverList()
      }
    },
    clearFilter() {
      this.search_input = ''
      this.changePage()
    },
    handleCheckAllChange(val) {
      this.checkedDrivers = val ? this.driver_list : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length

      this.checkAll = checkedCount === this.driver_list.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.driver_list.length
    },
    beforeDelete(id = 0) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      })
        .then(() => {
          if (id) {
            this.deleteSingleDriver(id)
          } else {
            this.dellArrDriver()
          }
        })
        .catch(() => {})
    },
    async dellArrDriver() {
      for (let index = 0; index < this.checkedDrivers.length; index++) {
        const element = this.checkedDrivers[index]

        await this.deleteDriver(element.id)
      }

      this.filterDriverList()
    },
    async deleteSingleDriver(id) {
      await this.deleteDriver(id)
      this.filterDriverList()
    },
    async deleteDriver(id) {
      try {
        this.isDeleting = true
        await Driver.deleteDriver(id)
      } catch {
        this.$message({
          message: 'При удалении произошла ошибка',
          type: 'error',
        })
      } finally {
        this.isDeleting = false
      }
    },
    infoDriver(driver, e, flag = false) {
      if (this.isMobile && !flag) {
        return false
      }
      const val = e.target.classList.value

      if (!e.target.dataset.goal && val.indexOf('el-checkbox') === -1) {
        this.editDriver = { ...driver }
        this.dialogVisible = true
      }
    },
    closeModal(driver, id) {
      if (driver) {
        this.$store.commit(`drivers/${UPDATE_DRIVER}`, { id, driver })
        this.filterDriverList()
      }
      this.dialogVisible = false
    },
    sendApprove(newStatus) {
      this.checkedDrivers.map(driver => {
        Approvements.postApprovements({
          link_by_rel: 'drivers',
          link_by_id: driver.id,
          status: newStatus,
          user_org_inn: Number(this.cur_org_inn),
        }).then(() => this.getDriverList())
      })
    },
  },
}
</script>

<style lang="sass">
.el-message-box.before-del
  width: 90%
.no-events
  i
    pointer-events: none
.driver_section_filter
  padding: 0 15px
  .top-section-left
    position: relative
    .search-input
      margin: 30px 0 15px 0
  .select-all-d
    margin: 0
    &:hover
      cursor: pointer
      text-decoration: underline
      .el-checkbox__label
        color: #3498DB
        text-decoration: underline
  .top-section-right
    p
      font-size: 18px
      line-height: 21px
      color: #3498DB
      &:hover
        text-decoration: underline
        cursor: pointer
    .center
      display: flex
      align-items: center
      justify-content: space-between
      span
        margin-left: 14px

.middle-section
  .check-list
    cursor: pointer
    margin: 20px 0
    background: #fff
    align-items: center
    height: 100px
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
    .el-checkbox__label
        display: none
    .auto-list_col
      height: 100px
      .auto-list_col_centered
        height: 100%
        display: grid
        align-items: center
    .check-list-time
      text-align: center
    .check-list-phone
      font-size: 16px
      line-height: 21px
    .check-list-autos
      font-size: 14px
      line-height: 21px
    .check-list-action
      img
          margin: 10px
      .single-p
        font-size: 18px
        text-align: center
        color: #dd6161
        &.is6
          color: limegreen
    .check-list-person
      p
        margin: 5px
        font-size: 18px
        line-height: 22px
    .grey
      color: #98A9BC
    .doc-phone
      border: none
      font-size: 18px
      color: #98A9BC
      outline: none
      cursor: pointer

.bottom-section
  .pagination
    margin-bottom: 20px
    display: flex
    justify-content: flex-end
  .el-pagination .btn-next, .el-pagination .btn-prev
    background: transparent
  .el-dialog, .el-pager li
    background: transparent
  .bottom-section-action
    display: flex
    align-items: center
    justify-content: flex-end
    p
      font-size: 14px
      line-height: 17px
      text-transform: uppercase
      font-weight: bold
      margin: 0
    .el-button
      margin-left: 30px
      border: none
      border-radius: unset
      background: #E9E9E9
/*added new style*/
.middle-section.middle-section_driver
  .check-list
    .el-row
      height: 100%
    .check-list-person
      p
        margin: 0
    .check-list_phone, .check-list_date
      p
        font-size: 16px
        font-weight: normal
    .check-list_date
      p
        text-align: center
        line-height: 1
    .el-rate
      height: auto
    .auto-list_col
      height: auto
    .check-list-time
      padding-left: 25px
    .double_button
      margin-right: 35px
      .check-list-action
        display: flex
        p
          margin: 0 5px
    .black_color
      color: #000000
    .red_color
      color: rgb(255, 0, 0)
.not_verified
  filter: invert(40%) grayscale(100%) brightness(55%) sepia(100%) hue-rotate(-50deg) saturate(400%) contrast(2);
.verify_bit
  margin-right: 30px
.not_approved
  visibility: hidden
.top-section_driver
  flex-direction: column
  .el-button--primary
    margin-bottom: 30px
</style>
